import React from 'react';
import { TiHeartFullOutline } from 'react-icons/ti';

const Footer = () => {
  return (
    <div className="w-screen flex px-4 py-8 justify-center">
      <span className="mr-1 font-medium">Made with</span>
      <TiHeartFullOutline size="1.5rem" className="text-red-600" />
      <span className="ml-1 font-medium">by <a className="hover:underline" href="https://www.smart-gaming.it">Smart Gaming</a></span>
    </div>
  );
};

export default Footer;
